import lucha from '../assets/events/lucha.jpeg'
import airtel from '../assets/events/Airtel.png'
import ista from '../assets/events/ista.JPG'
import orange from '../assets/events/orange.png'
import isp from '../assets/events/ispbkv.jpeg'
import isdrrgl from '../assets/events/isdrgl.jpeg'

export const initDataOrga = [
    {
        name: 'LUCHA',
        resume: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur quo dolorem porro, nostrum libero dignissimos minima explicabo ipsam illo beatae in magnam adipisci error ad quas iste fugit et saepe?',
        image: lucha
    },
    {
        name: 'AIRTEL',
        resume: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur quo dolorem porro, nostrum libero dignissimos minima explicabo ipsam illo beatae in magnam adipisci error ad quas iste fugit et saepe?',
        image: airtel
    },
    {
        name: 'ORANGE',
        resume: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur quo dolorem porro, nostrum libero dignissimos minima explicabo ipsam illo beatae in magnam adipisci error ad quas iste fugit et saepe?',
        image: orange
    },
    {
        name: 'ISDGL-GL',
        resume: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur quo dolorem porro, nostrum libero dignissimos minima explicabo ipsam illo beatae in magnam adipisci error ad quas iste fugit et saepe?',
        image: isdrrgl
    },
    {
        name: 'ISTA Kinshasa',
        resume: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur quo dolorem porro, nostrum libero dignissimos minima explicabo ipsam illo beatae in magnam adipisci error ad quas iste fugit et saepe?',
        image: ista
    },
    {
        name: 'ISP BUKAVU',
        resume: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur quo dolorem porro, nostrum libero dignissimos minima explicabo ipsam illo beatae in magnam adipisci error ad quas iste fugit et saepe?',
        image: isp,
    },


]